import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlusBoxOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7228_8632)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M26.5985 26.5988V3.40111H3.40087V26.5988H26.5985ZM26.5985 0.0871582C27.4775 0.0871582 28.3204 0.436306 28.9419 1.05779C29.5633 1.67928 29.9125 2.5222 29.9125 3.40111V26.5988C29.9125 27.4777 29.5633 28.3206 28.9419 28.9421C28.3204 29.5636 27.4775 29.9127 26.5985 29.9127H3.40087C2.52195 29.9127 1.67904 29.5636 1.05755 28.9421C0.436062 28.3206 0.0869141 27.4777 0.0869141 26.5988V3.40111C0.0869141 2.5222 0.436062 1.67928 1.05755 1.05779C1.67904 0.436306 2.52195 0.0871582 3.40087 0.0871582H26.5985ZM23.2846 13.343V16.6569H6.71482V13.343H23.2846Z",
			fill: "#79C912"
		}), /* @__PURE__ */ _jsx("line", {
			x1: 15.5,
			y1: 6.75,
			x2: 15.5,
			y2: 23.25,
			stroke: "#79C912",
			strokeWidth: 4
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7228_8632",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 30,
			height: 30,
			fill: "white"
		})
	}) })]
});
export default SvgIconPlusBoxOutline;
